var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/core/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import createTextMaskInputElement from './createTextMaskInputElement';
import { isNil } from './utilities';
export class MaskedInput extends React.PureComponent {
    constructor(...args) {
        super(...args);
        this.setRef = this.setRef.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    setRef(inputElement) {
        this.inputElement = inputElement;
    }
    initTextMask() {
        const { props, props: { value }, } = this;
        this.textMaskInputElement = createTextMaskInputElement(Object.assign({ inputElement: this.inputElement }, props));
        this.textMaskInputElement.update(value);
    }
    componentDidMount() {
        this.initTextMask();
    }
    componentDidUpdate(prevProps) {
        // Getting props affecting value
        const { value, pipe, mask, guide, placeholderChar, showMask } = this.props;
        // Сalculate that settings was changed:
        // - `pipe` converting to string, to compare function content
        // - `mask` converting to string, to compare values or function content
        // - `keepCharPositions` exludes, because it affect only cursor position
        const settings = { guide, placeholderChar, showMask };
        const isPipeChanged = typeof pipe === 'function' && typeof prevProps.pipe === 'function'
            ? pipe.toString() !== prevProps.pipe.toString()
            : (isNil(pipe) && !isNil(prevProps.pipe)) ||
                (!isNil(pipe) && isNil(prevProps.pipe));
        const isMaskChanged = mask.toString() !== prevProps.mask.toString();
        const isSettingChanged = Object.keys(settings).some((prop) => settings[prop] !== prevProps[prop]) ||
            isMaskChanged ||
            isPipeChanged;
        // Сalculate that value was changed
        const isValueChanged = value !== this.inputElement.value;
        // Check value and settings to prevent duplicating update() call
        if (isValueChanged || isSettingChanged) {
            this.initTextMask();
        }
    }
    render() {
        const _a = this.props, { render } = _a, props = __rest(_a, ["render"]);
        delete props.mask;
        delete props.guide;
        delete props.pipe;
        delete props.placeholderChar;
        delete props.keepCharPositions;
        delete props.value;
        delete props.onBlur;
        delete props.onChange;
        delete props.showMask;
        return render(this.setRef, Object.assign({ onBlur: this.onBlur, onChange: this.onChange, defaultValue: this.props.value }, props));
    }
    onChange(event) {
        this.textMaskInputElement.update();
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(event);
        }
    }
    onBlur(event) {
        if (typeof this.props.onBlur === 'function') {
            this.props.onBlur(event);
        }
    }
}
MaskedInput.propTypes = {
    mask: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.bool,
        PropTypes.shape({
            mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
            pipe: PropTypes.func,
        }),
    ]).isRequired,
    guide: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pipe: PropTypes.func,
    placeholderChar: PropTypes.string,
    keepCharPositions: PropTypes.bool,
    showMask: PropTypes.bool,
};
MaskedInput.defaultProps = {
    render: (ref, props) => _jsx("input", Object.assign({ ref: ref }, props), void 0),
};
